<template>
    <section id="inscriere" class="form">
        <div class="container">
            <div class="form__wrapper mobile-no-anim">
                <div class="form__shapes">
                    <div data-aos="fade-left" data-aos-duration="2000" data-aos-delay="200" class="circle__pink color-change mobile-no-anim"></div>
                    <div data-aos="fade-right" data-aos-duration="2000" data-aos-delay="2500" class="circle__blue--big mobile-no-anim"></div>
                </div>
                <div data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200" class="form__title mobile-no-anim">ÎNSCRIE BONUL FISCAL PENTRU A INTRA ÎN CONCURS</div>


                <main  class="formContain mobile-no-anim">
                    <section class="form-group mobile-no-anim">
                        <input id="fbf" v-model="$v.formResponses.bf.$model" type="text" placeholder="Număr bon fiscal" title="Introdu numărul bonului fiscal" autocomplete="off">
                        <p v-if="errors" class="form__error">
                            <span v-if="!$v.formResponses.bf.required">Câmp obligatoriu.</span>
                            <span v-if="!$v.formResponses.bf.minLength">Trebuie să conțină minimum {{ $v.formResponses.bf.$params.minLength.min }} caractere.</span>
                            <span v-if="promotifulErrors.numarbon" >{{promotifulErrors.numarbon}}</span>
                        </p>
                        <VuePureLightbox id="bf-thumb" thumbnail="images/magnifying-bf.jpg" :images="['/images/receipt.jpg']"></VuePureLightbox>
                    </section>
                    <section data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500"  class="form-group mobile-no-anim date-index">
                        <datepicker id="fdatabf" :disabledDates="disabledDates" :value="state.datePlaceholder" :language="ro" v-model="$v.formResponses.databf.$model" placeholder="Data bonului fiscal"></datepicker>
                        <p v-if="errors" class="form__error">
                            <span v-if="!$v.formResponses.databf.required">Câmp obligatoriu. Data bonului fiscal trebuie să fie în intervalul campaniei</span>
                            <span v-if="promotifulErrors.databon" >{{promotifulErrors.databon}}</span>
                        </p>
                    </section>
                    <section data-aos="fade-up" data-aos-duration="2000" data-aos-delay="600"  class="form-group mobile-no-anim">
                        <input id="fnume" v-model="$v.formResponses.nume.$model" type="text" placeholder="Nume și Prenume" title="Introdu numele și prenumele" autocomplete="off">
                        <p v-if="errors" class="form__error">
                            <span v-if="!$v.formResponses.nume.required">Câmp obligatoriu.</span>
                            <span v-if="!$v.formResponses.nume.minLength">Trebuie să conțină minimum {{ $v.formResponses.nume.$params.minLength.min }} caractere.</span>
                            <span v-if="!$v.formResponses.nume.alpha">Sunt acceptate doar litere.</span>
                            <span v-if="promotifulErrors.Nume" >{{promotifulErrors.Nume}}</span>
                        </p>
                    </section>
                    <section data-aos="fade-up" data-aos-duration="2000" data-aos-delay="700"  class="form-group mobile-no-anim">
                        <input id="ftel" v-model="$v.formResponses.tel.$model" type="tel" placeholder="Număr de telefon" title="Introdu numărul de telefon" autocomplete="off">
                        <p v-if="errors" class="form__error">
                            <span v-if="!$v.formResponses.tel.required">Câmp obligatoriu.</span>
                            <span v-if="!$v.formResponses.tel.minLength">Trebuie să conțină minimum {{ $v.formResponses.tel.$params.minLength.min }} cifre.</span>
                            <span v-if="!$v.formResponses.tel.numeric">Sunt acceptate doar cifre.</span>
                            <span v-if="promotifulErrors.mobil" >{{promotifulErrors.mobil}}</span>
                        </p>
                    </section>

                    <section data-aos="fade-up" data-aos-duration="2000" data-aos-delay="700"  class="form-group check mobile-no-anim">
                        <input type="checkbox" id="accept" name="accept" v-model="$v.formResponses.accept.$model" />
                        <label for="accept" class="max-w-2xxl">Am citit și sunt de acord cu
                            <strong><a class="checkbox--a" target="_blank" rel="noopener noreferrer" href="/docs/Regulament-Campanie-Distractie-in-Familie-cu-Pufina_autentificat.pdf">Regulamentul Campaniei</a></strong>
                        </label>
                        <p v-if="errors" class="form__error form__errror--check">
                            <span v-if="!$v.formResponses.accept.sameAs || !$v.formResponses.accept.required">Trebuie să accepți regulamentul campaniei</span>
                            <span v-if="promotifulErrors.termeni" >{{promotifulErrors.termeni}}</span>
                        </p>
                    </section>

                    <section data-aos="fade-up" data-aos-duration="2000" data-aos-delay="800" class="form-group--cta mobile-no-anim">
                        <button @click.prevent="submitForm" class="form__cta cta--blue-2 submit">Înscrie bonul</button>
                        <p v-if="errors" class="form__error--main">Unele câmpuri din formular nu sunt valide
                            <br>te rugăm sa corectezi câmpurile invalide și să retrimiți formularul.</p>
                        <p v-else-if="empty && uiState === 'submit clicked'" class="form__error--main">Completează toate câmpurile!</p>
                        <p v-else-if="errors && uiState === 'submit clicked'" class="form__error--main">Completează toate câmpurile!</p>
                        <p v-else-if="invalid && uiState === 'submit clicked'" class="form__error--main">Trebuie sa completezi toate câmpurile si sa accepti termenii si conditiile si regulamentul campaniei!</p>
                        <p v-else-if="server_error && uiState === 'submit clicked'" class="form__error--main">{{ server_error}}</p>
                        <p v-else-if="uiState === 'form submitted'" class="form__success">{{ success_message }}</p>
                    </section>
                </main>
            </div>
        </div>
    </section>
</template>



<script>
// Datepicker
import { required, minLength, maxLength, between, minValue, maxValue, alpha, alphaNum, numeric, sameAs } from "vuelidate/lib/validators";
import Datepicker from 'vuejs-datepicker';
import * as lang from "vuejs-datepicker/src/locale";
import {en, ro} from 'vuejs-datepicker/dist/locale';

// Lightbox
import VuePureLightbox from 'vue-pure-lightbox'
import styles from 'vue-pure-lightbox/dist/VuePureLightbox.css'

import axios from 'axios';
import moment from 'moment';


const state = {
  date1: new Date(),
  datePlaceholder: 'Data bonului fiscal'
};

export default {
    components: {
        Datepicker,
        VuePureLightbox,
    },
    data() {
        return {
            uiState: "submit not clicked",
            errors: false,
            empty: true,
            invalid: null,
            server_error: null,
            success_message: 'Datele au fost trimise',
            promotifulErrors: {},
            formResponses: {
                bf: null,
                databf: null,
                nume: null,
                tel: null,
                accept: null
            },
            format: "dd MMMM yyyy",
            disabledDates: {
                to: new Date(2020, 3, 15),
                from: new Date(2020, 6, 1),
            },
            state: state,
            language: "ro",
            ro: ro,
        };
    },
    validations: {
        formResponses: {
            bf: {
                required,
                minLength: minLength(2)
            },
            databf: {
                required
            },
            nume: {
                required,
                minLength: minLength(3)
            },
            tel: {
                required,
                numeric,
                minLength: minLength(10),
                maxLength: maxLength(10)
            },
            accept: {
                required,
                sameAs: sameAs( () => true )
            }
        }
    },
    methods: {
        submitForm() {
            this.empty = !this.$v.formResponses.$anyDirty;
            this.errors = this.$v.formResponses.$anyError;
            this.invalid = this.$v.formResponses.$invalid;
            this.uiState = "submit clicked";
            if (this.errors === false && this.invalid === false) {
                this.promotifulErrors = {
                    numarbon: null,
                    databon: null,
                    Nume: null,
                    mobil: null,
                    termeni: null
                };
                let parent = this;

                axios.post('/promotiful-connection/process.php', {
                    numarbon: this.$v.formResponses.$model.bf,
                    Nume: this.$v.formResponses.$model.nume,
                    mobil: this.$v.formResponses.$model.tel,
                    databon: moment(this.$v.formResponses.$model.databf).format('YYYY-MM-DD'),
                    termeni: this.$v.formResponses.$model.accept ? 'on' : ''
                }).then((result) => {
                    if (result.data.response == 'success') {
                        parent.success_message = result.data.message;
                        parent.uiState = "form submitted";
                    } else if (result.data.response == 'general_error') {
                        parent.server_error = result.data.message;
                    } else if (result.data.response == 'error') {
                        for (const name in result.data.errors) {
                            parent.promotifulErrors[name] = result.data.errors[name];
                        }
                        parent.errors = true;
                    } else {
                        parent.server_error = 'O eroare a fost intampinata la trimiterea informatiilor te rugam sa incerci mai tarziu';
                    }
                }).catch((error) => {
                    console.log(error)
                    parent.server_error = 'O eroare a fost intampinata la trimiterea informatiilor te rugam sa incerci mai tarziu';
                });
            }
        },
        setDisabledDays(elem) {
            if (elem.target.value === "undefined") {
                return;
            }
            let disabledDays = elem.target.value.split(",").map(day => parseInt(day));
            this.disabledDates = {
                from: this.disabledDates.from,
                to: this.disabledDates.to,
                daysOfMonth: disabledDays
            };
        },
        disableTo(val) {
            if (typeof this.disabled.to === "undefined") {
                this.disabledDates = {
                to: null,
                daysOfMonth: this.disabledDates.daysOfMonth,
                from: this.disabled.from
                };
            }
            this.disabledDates.to = val;
        },
        disableFrom(val) {
            if (typeof this.disabledDates.from === "undefined") {
                this.disabled = {
                to: this.disabledDates.to,
                daysOfMonth: this.disabled.daysOfMonth,
                from: null
                };
            }
            this.disabledDates.from = val;
        },
    },
};
</script>

<style scoped>
    main {
        @apply flex items-center justify-center flex-wrap w-full;
    }

    /* Used to format the input type date -- disabled if vue datepicker is in use */
    /* input[type="date"]::-webkit-datetime-edit, input[type="date"]::-webkit-inner-spin-button, input[type="date"]::-webkit-clear-button {
        color: #fff;
        position: relative;
    }

    input[type="date"]::-webkit-datetime-edit-year-field{
        position: absolute !important;
        border-left:1px solid #8c8c8c;
        padding: 2px;
        color:#000;
        left: 56px;
    }

    input[type="date"]::-webkit-datetime-edit-month-field{
        position: absolute !important;
        border-left:1px solid #8c8c8c;
        padding: 2px;
        color:#000;
        left: 26px;
    }


    input[type="date"]::-webkit-datetime-edit-day-field{
        position: absolute !important;
        color:#000;
        padding: 2px;
        left: 4px;
    } */

    .vdp-datepicker {
        position: relative;
        text-align: left;
        width: 100%;
    }
</style>
